import React, { Component } from 'react';
import { Text } from 'pp-react';

class TextModule extends Component {
  centerStyle = () => {
    return { textAlign: 'center' };
  }
  render() {
    const title = this.props.title;
    const content = this.props.content.replace(/\n|\r\n|\r/, '<br/>');
    const textCenter = this.props.textCenter || false;
    return (
      <div>
        <Text size='xl3' style={textCenter ? this.centerStyle() : null}>{title}</Text>
        <Text size='md' dangerouslySetInnerHTML={{ __html: content }}></Text>
      </div>
    );
  }
}

TextModule.defaultProps = {};

export default TextModule;
